module.exports = __webpack_public_path__ + "img/pm_g.ca040b87.png";